import React from 'react'
import _InstrumentDetail from './InstrumentDetail'
import ChildInstrumentDiv from './ChildInstrumentDiv'
import InstrumentPlanDiv from './InspectionPlan/InstrumentPlanDiv'
import InstrumentLogDiv from './InspectionPlan/InstrumentLogDiv'
import MeterageParaSettingDiv from './MeterageParaSettingDiv'
import MaintainParaSettingDiv from './MaintainParaSettingDiv'
import SpotItemSettingDiv from './SpotItemSettingDiv'

import AutoAddInstrumentPlanDiv from './AutoAddInstrumentPlanDiv'
import InstrumentAdjustDetail from './InstrumentMaintain/InstrumentAdjustDetail'
import InstrumentCheckDetail from './InstrumentMaintain/InstrumentCheckDetail'
import InstrumentMaintainDetail from './InstrumentMaintain/InstrumentMaintainDetail'
import InstrumentRepairDetail from './InstrumentRepair/InstrumentRepairDetail'
import { exportFile } from 'tyan/public/index'
import ChangeInstrumentNumberDiv from './ChangeInstrumentNumberDiv'
const tag = '<span style="color:red;">*</span>'
class InstrumentDetail extends React.Component {
	state = {
		id: this.props.id || 0,
		fatherID: this.props.fatherID || 0,
		readOnly: this.props.readOnly || false,
	}

	SettingsDiv = {
		'关联设备': ChildInstrumentDiv,
		'设备计划': InstrumentPlanDiv,
		'设备日志': InstrumentLogDiv,
		'计量参数': MeterageParaSettingDiv,
		'保养参数': MaintainParaSettingDiv,
		'点检项目': SpotItemSettingDiv,

		'自动补充计划': AutoAddInstrumentPlanDiv,
		'计量': InstrumentAdjustDetail,
		'期间核查': InstrumentCheckDetail,
		'维护保养': InstrumentMaintainDetail,
		'维修': InstrumentRepairDetail,

		'变更设备编号': ChangeInstrumentNumberDiv,
	}

	componentDidMount = () => {
		this.doGetInstrument(this.state.id)
	}

	doGetInstrument = (id, fieldsets = '') => {
		const { fatherID, readOnly } = this.state
		console.log('readOnly1',readOnly)
		Tyan.doPostEvent('GetInstrument', {
			data: { id, fatherID, readOnly },
			onEnd: ({ errorMessage, optionsParas, initValues基本信息, initValues设备计划, initValues设备日志, initValues计量参数, initValues保养参数, initValues点检项目, initValues子设备, readOnly }) => {
				if (errorMessage) {
					Tyan.pubForm.showError(errorMessage)
				} else {
					if (fieldsets == '' || fieldsets == '变更设备编号') {
						this.setState({ id, optionsParas, initValues基本信息, changedValues基本信息: {}, initValues设备计划, initValues设备日志, initValues计量参数, initValues保养参数, initValues点检项目, initValues子设备 })
					} else if (fieldsets == '设备计划' || fieldsets == '自动补充计划') {
						if (this.bChanged()) {
							this.setState({ initValues设备计划 })
						} else {
							this.setState({ initValues基本信息, initValues设备计划, })
						}
					} else if (fieldsets == '设备日志') {
						if (this.bChanged()) {
							this.setState({ initValues设备日志 })
						} else {
							this.setState({ initValues基本信息, initValues设备日志, })
						}
					} else if (fieldsets == '计量参数') {
						this.setState({ initValues计量参数 })
					} else if (fieldsets == '保养参数') {
						this.setState({ initValues保养参数 })
					} else if (fieldsets == '点检项目') {
						this.setState({ initValues点检项目 })
					} else if (fieldsets == '关联设备') {
						this.setState({ initValues子设备 })
					}
					console.log('readOnly2',readOnly)
					this.setState({ readOnly })
				}
			},
		})
	}

	handlerSave = () => {
		const { fatherID } = this.state
		Tyan.doPostEvent('SaveInstrument', {
			data: { fatherID, ...Tyan.utility.getChangedFieldsets(this, '基本信息', false) },
			onEnd: ({ errorMessage, id }) => {
				if (errorMessage) {
					Tyan.pubForm.showError(errorMessage)
				} else {
					Ext.toast('保存成功')
					this.doGetInstrument(id)
				}
			},
		})
	}

	handlerDelete = () => {
		const { onClose } = this.props
		const { id } = this.state
		Tyan.pubForm.showConfirm('确定要删除？', () => {
			Tyan.doPostEvent('DelInstrument', {
				data: { id },
				onEnd: ({ errorMessage }) => {
					if (errorMessage) {
						Tyan.pubForm.showError(errorMessage)
					} else {
						Ext.toast('删除成功')
						onClose && onClose()
					}
				}
			})
		})
	}

	handlerClose = () => {
		const { onClose } = this.props
		if (!this.bChanged()) {
			onClose && onClose()
			return
		}
		Tyan.pubForm.showConfirm('确定要放弃更改吗？', onClose)
	}

	handlerPrint = () => {
		const { id } = this.state
		Tyan.doPostEvent('PrintInstrument', {
			data: { id },
			onEnd: ({ errorMessage, FID }) => {
				if (errorMessage) {
					Tyan.pubForm.showError(errorMessage)
				} else {
					exportFile(null, null, "GetFile?FID=" + FID)
				}
			}
		})
	}

	handlerDeleteLink = (id) => {
		const { id: instrumentID } = this.state
		Tyan.pubForm.showConfirm('确定要取消关联？', () => {
			Tyan.doPostEvent('DelInstrumentCombination', {
				data: { instrumentID, childInstrumentID: id },
				onEnd: ({ errorMessage }) => {
					if (errorMessage) {
						Tyan.pubForm.showError(errorMessage)
					} else {
						Ext.toast('操作成功')
						this.doGetInstrument(instrumentID, '关联设备')
					}
				}
			})
		})
	}


	canSave = () => {

		return this.bChanged() && !Tyan.checkForm.checkLimited(this) && Tyan.utility.getFormValue(this, '基本信息', 'fatherID') > 0
	}

	bChanged = () => {
		return Tyan.utility.hasChangedValues(this)
	}


	handlerShowDetail = (title, id, planName, onlyRead) => {
		const { id: instrumentID, readOnly } = this.state

		if (['启用', '停用', '报废'].includes(title)) {
			title = '设备日志'
		}

		const Comp = this.SettingsDiv[title]
		Tyan.pubForm.showDialog(title, props => <Comp {...props} id={id} instrumentID={instrumentID} planName={planName} readOnly={readOnly || onlyRead} onRefresh={() => this.doGetInstrument(instrumentID, title)} />)
	}

	handlerChange = (type, v) => {
		switch (type) {
			case '每周工作方式':
				const { optionsParas: { obj每周工作时间 } } = this.state
				if (obj每周工作时间[v]) {
					Tyan.utility.changeItemsValue(this, '基本信息', ['每周工作时间'], [obj每周工作时间[v]])
				} else {
					Tyan.utility.changeItemsValue(this, '基本信息', ['每周工作时间'], [null])
				}
				break
			case '设备对接人员':
				Tyan.doPostEvent('GetRelationInfo', {
					data: { type: '人员姓名', objRelationInfo: { '部门属性': Tyan.utility.getFormValue(this, '基本信息', '部门属性'), '人员姓名': v } },
					onEnd: ({ errorMessage, optionsParas }) => {
						if (optionsParas) {
							this.setState({ optionsParas: { ...this.state.optionsParas, ...optionsParas } })
						}
					}
				})
				break
		}
	}


	fieldset基本信息 = () => {
		const { optionsParas: { obj设备分类 } } = this.state
		const { list: optionsList } = Tyan.utility.getListFromValues('设备分类', null, obj设备分类, {})
		const hasPlan = Tyan.utility.getFormValue(this, '基本信息', 'hasPlan')
		const bPlanInstrument = Tyan.utility.getFormValue(this, '基本信息', '是否排工设备') == '是'
		const 每周工作方式 = Tyan.utility.getFormValue(this, '基本信息', '每周工作方式')

		return [
			{ _text: '设备编号', required: true, disabled: hasPlan, minWidth: '50%', },
			{ _text: '设备名称', required: true, minWidth: '50%', },
			{ _text: '设备英文名称', name:'英文设备名称', required: true, minWidth: '50%', },
			{ _text: '设备型号', required: true, minWidth: '50%', },
			{ _text: '存放位置', minWidth: '50%', },
			{ _text: '设备尺寸mm(长×宽×高）',name:'设备尺寸', required: true, minWidth: '50%', },
			{ _text: '设备功率（KW）', name:'最大安装功率', minWidth: '50%', },
			{ _text: '冷却液需求', required: true, minWidth: '50%', },
			{
				_treeselect: '设备分类', name: 'fatherID', required: true, displayField: '分类名称', options: optionsList,
				leafOnly: false, displayFull: '/', displayName: 'fullName', fullNameField: 'fullName', rootText: '全部',
				onChange: ([fatherID, fullName]) => Tyan.doPostEvent('GetFatherRelation', {
					data: { id: fatherID },
					onEnd: ({ photoRequired }) => { Tyan.utility.changeItemsValue(this, '基本信息', ['photoRequired'], [photoRequired]) }
				})
			},
			{ _radio: '瓶颈设备', required: true, minWidth: '50%', },
			{ _text: '设备状态', disabled: true, minWidth: '50%', },
			{ _select: '试验类型', editable: true, forceSelection: false, minWidth: '50%', },
			{ _text: '主要功能', minWidth: '100%', required: true, maxRows: 3, },
			{ _text: '技术指标', minWidth: '100%', required: true, maxRows: 3, },
			{ _text: '测量范围', minWidth: '100%', required: true, maxRows: 3, },
			{ _text: '分辨率', required: true, minWidth: '50%', },
			{ _select: '设备责任人',name:'管理员', required: true, editable: true, forceSelection: false, minWidth: '50%', },
			{ _select: '设备对接人员', editable: true, forceSelection: false, onChange: (v) => this.handlerChange('设备对接人员', v), minWidth: '100%', },
			{ _select: '设备厂商', name:'设备厂家', editable: true, forceSelection: false, minWidth: '50%', },
			{ _text: '厂商联系人', minWidth: '50%', },
			{ _text: '厂商电话', name:'电话', minWidth: '50%', },
			{ _text: '厂商邮箱', name:'邮箱', minWidth: '50%', },
			{ _date: '验收日期', required: true, minWidth: '50%', },
			{ _date: '开始使用日期', required: true, minWidth: '50%', },
			{ _text: '出厂编号', minWidth: '50%', },
			{ _select: '设备类型', required: true, minWidth: '50%', },
			
			{ _text: '备注', minWidth: '100%', maxRows: 3, },
			{ _radio: '是否排工设备', },
			{ _text: '每天工作时段', cdt: () => bPlanInstrument, },
			{ _int: '每天工作时长', disabled: true, textAlign: 'left', cdt: () => bPlanInstrument, },
			{ _radio: '每周工作方式', cdt: () => bPlanInstrument, onChange: (v) => this.handlerChange('每周工作方式', v) },
			{ _checkbox: '每周工作时间', itemMinWidth: 20, disabled: 每周工作方式 != '指定时间', cdt: () => bPlanInstrument, },
			{ _radio: '节假日是否工作', cdt: () => bPlanInstrument, },
			{ _radio: '加班日是否工作', cdt: () => bPlanInstrument, },
			{ _files: '安全操作规程', disabled: true, },
			{ _files: '设备验收记录表' },
			{ _files: '设备档案表' },
			{ _files: '附件', },
		]
	}

	fieldset设备照片 = () => {
		return [
			{ _files: '', name: '设备照片', margin: 0, multiple: false, disableDelete: Tyan.loginInfo.roles.indexOf('设备管理员') == -1, limit: 0, accept: 'image/*', imageSize: [300, 200], required: Tyan.utility.getFormValue(this, '基本信息', 'photoRequired'), },
		]
	}

	fieldset子设备 = () => {
		const { showDetail } = this.props
		const { readOnly } = this.state
		return [
			{
				_grid: '', name: '子设备', rowNumbers: true, height: '100%',
				columns: [
					{
						_text: '设备编号', minWidth: 150, flex: 1,
						tools: [!readOnly && showDetail && {
							_tool: '', btnName: '查_看2', zone: 'end',
							handler: (that, data) => { showDetail(props => <_InstrumentDetail {...props} id={data.id} readOnly={true} />) },
						}]
					},
					{ _text: '设备名称', minWidth: 150, flex: 2, },
					{ _button: '', btnName: '链_接1', maxWidth: 50, tooltip: '取消关联', handler: (that, data) => this.handlerDeleteLink(data.id), },
				],
				buttons: readOnly ? [] : [
					{ _button: '关联...', btnName: '链接', handler: () => this.handlerShowDetail('关联设备', 0) }
				],
				onDoubleTap: data => { this.handlerShowDetail('关联设备', data.id) },
			}
		]
	}

	fieldset设备计划 = () => {
		const { readOnly } = this.state
		return [
			{
				_grid: '', name: '设备计划', rowNumbers: true, height: '100%',
				columns: [
					{ _text: '类型', minWidth: 100, },
					{ _date: '开始时间', minWidth: 150, },
					{ _date: '结束时间', minWidth: 150, },
					{ _text: '内容', minWidth: 200, flex: 1, },
					{ _text: '技术要求', minWidth: 200, flex: 1, },
					{ _text: '备注', minWidth: 200, flex: 1, },
				],
				buttons: readOnly ? [] : [
					{ _button: '自动补充计划...', btnName: '添加', handler: () => this.handlerShowDetail('自动补充计划', 0) },
					{ _button: '添加计划...', handler: () => this.handlerShowDetail('设备计划', 0) }
				],
				onDoubleTap: data => { this.handlerShowDetail('设备计划', data.id) },
			}
		]
	}

	fieldset设备日志 = () => {
		const { readOnly } = this.state
		return [
			{
				_grid: '', name: '设备日志', rowNumbers: true, height: '100%',
				columns: [
					{ _text: '类型', minWidth: 100, },
					{ _text: '计划时间', minWidth: 250, },
					{ _text: '实际执行时间', minWidth: 250, },
					{ _text: '内容', minWidth: 200, flex: 2, },
					{ _text: '技术要求', minWidth: 300, flex: 2, },
					{ _text: '备注', minWidth: 100, flex: 1, },
				],
				buttons: readOnly ? [] : [
					{ _button: '添加日志...', handler: () => this.handlerShowDetail('设备日志', 0) }
				],
				onDoubleTap: data => { this.handlerShowDetail(data['类型'], data.id, null, true) },
			},
		]
	}

	fieldset计量参数 = () => {
		const { readOnly } = this.state
		return [
			{
				_grid: '', name: '计量参数', rowNumbers: true, height: '100%',
				columns: [
					{ _text: '参数名称', minWidth: 200, },
					{ _text: '技术要求', minWidth: 150, flex: 1, },
					{ _int: '计量周期（月）', name: '计量周期', minWidth: 150, },
					{ _int: '期间核查周期（月）', name: '期间核查周期', minWidth: 150, },
					{ _date: '计量有效日期', minWidth: 150, },
					{ _date: '期间核查有效日期', minWidth: 150, },
					{ _text: '备注', minWidth: 150, flex: 1, },
				],
				buttons: readOnly ? [] : [
					{ _button: '添加参数...', handler: () => this.handlerShowDetail('计量参数', 0) }
				],
				onDoubleTap: data => { this.handlerShowDetail('计量参数', data.id) },
			},
		]
	}

	fieldset保养参数 = () => {
		const { readOnly } = this.state
		return [
			{
				_grid: '', name: '保养参数', rowNumbers: true, height: '100%',
				columns: [
					{ _text: '保养内容', minWidth: 200, flex: 2, },
					{ _text: '保养类型', minWidth: 150, flex: 1, },
					{ _int: '保养周期（月）', name: '保养周期', minWidth: 150, flex: 1, },
					{ _date: '保养有效日期', minWidth: 150, flex: 1, },
					{ _text: '备注', minWidth: 150, flex: 2, },
				],
				buttons: readOnly ? [] : [
					{ _button: '添加参数...', handler: () => this.handlerShowDetail('保养参数', 0) }
				],
				onDoubleTap: data => { this.handlerShowDetail('保养参数', data.id) },
			},
		]
	}

	fieldset点检项目 = () => {
		const { readOnly } = this.state
		return [
			{
				_grid: '', name: '点检项目', rowNumbers: true, height: '100%',
				columns: [
					{ _text: '项目名称', minWidth: 200, flex: 2, },
					{ _text: '点检类别', minWidth: 150, },
					{ _text: '点检频率', minWidth: 150, },
					{ _text: '输入方式', minWidth: 150, },
					{ _text: '点检说明', minWidth: 150, flex: 1, },
				],
				buttons: readOnly ? [] : [
					{ _button: '添加点检项目...', handler: () => this.handlerShowDetail('点检项目', 0) }
				],
				onDoubleTap: data => { this.handlerShowDetail('点检项目', data.id) },
			},
		]
	}

	render() {
		const { showMessage: Message, showBody: Body } = this.props
		const { id, readOnly, initValues基本信息 } = this.state
		if (!initValues基本信息) return <Message text={'请稍等 ...'} />

		const { 状态名称: statusName, 设备类型: combType } = initValues基本信息
		const bCanSave = this.canSave()
		const bChanged = this.bChanged()

		return <Body data={this}
			controls={
				readOnly ? [{ _button: '关闭', handler: this.handlerClose }] :
					[
						{ _button: '保存', handler: this.handlerSave, disabled: !bCanSave },
						{ _button: '删除', handler: this.handlerDelete, cdt: () => id > 0 },
						{ _button: '启用...', btnName: '启用', handler: () => this.handlerShowDetail('设备日志', 0, '启用'), disabled: bCanSave, cdt: () => id > 0 && ['未启用', '已停用', '已报废'].includes(statusName) },
						{ _button: '停用...', btnName: '停用', handler: () => this.handlerShowDetail('设备日志', 0, '停用'), disabled: bCanSave, cdt: () => id > 0 && ['空闲'].includes(statusName) },
						{ _button: '报废...', btnName: '报废', handler: () => this.handlerShowDetail('设备日志', 0, '报废'), disabled: bCanSave, cdt: () => id > 0 && ['空闲', '已停用'].includes(statusName) },
						{ _button: bChanged && '取消' || '关闭', handler: this.handlerClose },
						{ _button: '打印二维码', handler: this.handlerPrint, disabled: bChanged },
						{ _button: '变更设备编号', icon: 'edit', handler: () => this.handlerShowDetail('变更设备编号', id), disabled: bChanged },
					]}
			fieldsets={
				[
					id > 0 && {
						_fieldsets: [
							{ title: '组合设备', name: '子设备', _fieldset: this.fieldset子设备(), fullblock: true, cdt: () => combType == '组合' },
							{ title: '设备计划', name: '设备计划', _fieldset: this.fieldset设备计划(), fullblock: true },
							{ title: '设备日志', name: '设备日志', _fieldset: this.fieldset设备日志(), fullblock: true },
							{ title: '计量参数', name: '计量参数', _fieldset: this.fieldset计量参数(), fullblock: true },
							{ title: '保养参数', name: '保养参数', _fieldset: this.fieldset保养参数(), fullblock: true },
							{ title: '点检项目', name: '点检项目', _fieldset: this.fieldset点检项目(), fullblock: true },
						], height: '40%', docked: 'bottom',
					},
					{ title: `设备照片${Tyan.utility.getFormValue(this, '基本信息', 'photoRequired') ? tag : ''}`, name: '基本信息', _fieldset: this.fieldset设备照片(), minWidth: 300, docked: 'right', scrollable: true, layout: { type: 'vbox' }, disabled: readOnly },
					{ title: '设备信息', name: '基本信息', _fieldset: this.fieldset基本信息(), disabled: readOnly },
				]}
		/>
	}
}

export default InstrumentDetail